<template>
  <el-dialog
    class="update-name-popup-comp"
    width="486px"
    title="修改名称"
    center
    :visible.sync="updateNamePopupVisible"
  >
    <el-form inline>
      <el-form-item :label="label">
        <el-input v-model="updateName" placeholder="请输入考试名称"></el-input>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="updateNamePopupVisible = false"> 取消</el-button>
      <el-button type="primary" @click="confirm"> 确认</el-button>
    </div>
  </el-dialog>
</template>
<script lang="ts">
import { BaseComponent, Component, Emit, Prop, PropSync } from 'kuaidong-component'

@Component({
  components: {},
})
export default class UpdateNamePopup extends BaseComponent {
  @PropSync('visible', { type: Boolean, required: true })
  updateNamePopupVisible!: boolean

  @Prop({ type: String, required: true })
  name!: string

  @Prop({ type: String, default: '考试名称' })
  label!: string

  @Prop({ type: String, default: '请输入考试名称' })
  placeHolder!: string

  updateName = this.name

  confirm() {
    if (this.updateName === '') {
      this.toast('名称不能为空~')
    } else {
      this.confirmUpdateName()
    }
  }

  @Emit('confirm')
  confirmUpdateName() {
    this.updateNamePopupVisible = false
    return this.updateName
  }
}
</script>
<style lang="less">
.update-name-popup-comp {
  > .el-dialog {
    padding: 0 20px;
    > .el-dialog__header {
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      color: #0a1629;
    }
    > .el-dialog__body {
      display: flex;
      flex-direction: column;
      border-radius: 16px;
      flex: auto;
      padding: 0;
      text-align: left;
      overflow: hidden;
      > .el-form {
        > .el-form-item {
          > .el-form-item__content {
            > .el-input {
              width: 300px;
            }
          }
        }
      }

      > .footer {
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0 40px 0;
        > .el-button {
          width: 135px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
